var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoobetLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 43,
    viewBox: "0 0 165 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.502 0H143.54C144.124 0.0199614 144.708 0.0507351 145.29 0.104797C145.057 0.977275 144.813 1.84809 144.582 2.7214C141.291 2.4644 137.942 3.0466 134.943 4.39566C134.49 3.62215 134.026 2.85531 133.566 2.08596C136.353 0.7918 139.415 0.0682013 142.502 0Z",
    fill: "url(#paint0_linear_1751_36383)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.118 3.62635C149.359 2.76718 149.596 1.90718 149.829 1.04551C152.284 1.84396 154.612 3.03333 156.642 4.60778C157.93 5.60252 159.097 6.74531 160.135 7.98957C159.333 8.43787 158.538 8.89531 157.733 9.33779C155.461 6.71537 152.456 4.71008 149.118 3.62635Z",
    fill: "url(#paint1_linear_1751_36383)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.634 13.4115C124.113 9.89748 126.529 6.76188 129.618 4.44886C130.081 5.22319 130.534 6.00418 130.996 6.78018C128.513 8.71144 126.544 11.2565 125.293 14.1052C124.407 13.8739 123.522 13.6394 122.634 13.4115Z",
    fill: "url(#paint2_linear_1751_36383)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.414 4.97036C144.401 4.68341 147.465 5.18328 150.187 6.42421C152.774 7.59528 155.047 9.41758 156.736 11.6632C158.438 13.9172 159.541 16.6003 159.897 19.3816C160.326 22.6387 159.743 26.018 158.221 28.9473C156.709 31.8841 154.283 34.361 151.35 35.967C148.589 37.4907 145.381 38.2202 142.216 38.0596C139.533 37.9341 136.885 37.168 134.564 35.8456C131.926 34.351 129.713 32.1478 128.232 29.542C126.701 26.868 125.963 23.7715 126.115 20.7124C126.243 17.887 127.133 15.1007 128.67 12.7062C130.438 9.93491 133.059 7.69093 136.107 6.35185C137.782 5.61079 139.583 5.14336 141.414 4.97036ZM139.826 7.74748C137.171 8.27979 134.697 9.61886 132.823 11.5335C130.778 13.4423 129.365 15.9882 128.871 18.7121C128.621 19.973 128.647 21.2622 128.668 22.5397C128.779 25.326 129.827 28.0673 131.62 30.2365C132.106 30.8378 132.668 31.3742 133.226 31.9115C135.083 33.6656 137.472 34.8725 140.01 35.3399C141.399 35.6052 142.823 35.6027 144.232 35.5503C143.924 33.9892 143.735 32.3956 143.215 30.8819C142.964 30.2015 142.602 29.5652 142.2 28.9589C142.111 28.8283 142.02 28.6919 141.881 28.6079C141.369 28.3235 140.837 28.0665 140.261 27.9334C139.441 27.6398 138.509 27.4128 137.956 26.6958C137.394 26.1227 137.32 25.2877 137.303 24.535C137.285 23.4704 137.707 22.4731 137.998 21.4668C137.126 21.4077 136.244 21.3603 135.397 21.1382C134.675 20.9694 134.006 20.6417 133.348 20.3115C132.659 19.9613 132.118 19.4082 131.622 18.8352C131.135 18.263 130.952 17.5177 130.766 16.8124C130.746 16.582 130.59 16.1812 130.906 16.0863C131.746 15.9616 132.6 15.9782 133.448 15.9857C134.633 15.9924 135.798 16.2336 136.948 16.4847C138.315 16.8382 139.621 17.4886 140.646 18.4493C140.951 18.2247 141.289 18.0475 141.643 17.9095C141.624 17.2599 141.765 16.622 141.846 15.9807C142.092 14.259 142.958 12.6921 143.998 11.3073C144.153 11.1068 144.409 10.9297 144.678 11.0062C144.988 11.1043 145.239 11.3256 145.446 11.5634C145.951 12.2197 146.442 12.9324 146.589 13.7575C146.891 15.0558 146.76 16.4016 146.53 17.7007C146.937 17.813 147.368 17.9012 147.712 18.1565C148.018 18.3777 148.162 18.7354 148.33 19.0556C148.557 19.0415 148.77 19.1429 148.919 19.3059C149.334 19.7426 149.503 20.3547 149.511 20.9394C149.688 21.0617 149.869 21.1815 150.075 21.2497C151.058 21.5674 152.079 21.7545 153.061 22.0731C153.505 22.2952 153.994 22.049 154.465 22.1055C154.858 22.128 155.394 22.2228 155.514 22.6586C155.601 23.0736 155.618 23.5477 155.355 23.9095C155.168 24.1699 155.234 24.5159 155.072 24.7887C154.69 25.6537 153.824 26.1419 153.109 26.7133C152.916 26.8938 152.575 26.9004 152.476 27.1699C152.192 27.7704 151.681 28.2212 151.19 28.6587C150.69 29.0263 150.092 29.2683 149.477 29.369C148.803 29.4521 148.12 29.433 147.444 29.3839C147.784 31.1056 148.347 32.7774 148.914 34.4383C151.009 33.5617 152.781 32.0804 154.243 30.392C156.635 27.5608 157.776 23.7715 157.408 20.1227C157.18 17.7797 156.33 15.4983 154.969 13.5579C153.218 11.0503 150.629 9.10153 147.682 8.1359C145.166 7.29835 142.417 7.17692 139.826 7.74748Z",
    fill: "url(#paint3_linear_1751_36383)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.286 13.1412C161.078 12.7062 161.856 12.2479 162.647 11.8121C164.159 14.7722 165.005 18.0675 165 21.3819C165.005 22.4074 164.929 23.4321 164.792 24.4493C163.904 24.2239 163.019 23.9885 162.133 23.7556C162.605 20.1393 161.944 16.404 160.286 13.1412Z",
    fill: "url(#paint4_linear_1751_36383)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9861 16.929C26.7724 16.6786 28.6565 16.9647 30.2327 17.8422C31.8948 18.7521 33.1622 20.3199 33.6794 22.1131C34.1889 23.873 34.0485 25.8209 33.2286 27.471C32.3813 29.206 30.7873 30.5609 28.9278 31.1764C27.2657 31.732 25.4233 31.7553 23.7417 31.2604C22.0549 30.7672 20.5527 29.6776 19.6136 28.2171C18.0204 25.7793 18.0749 22.4167 19.7676 20.0404C20.95 18.3371 22.9081 17.2067 24.9861 16.929ZM25.2209 19.8275C24.1789 20.0371 23.2347 20.6559 22.6367 21.5159C21.3106 23.3956 21.616 26.2534 23.4457 27.7206C24.6033 28.6737 26.2799 28.9316 27.7004 28.4525C28.631 28.1414 29.434 27.4952 29.9384 26.6709C30.6231 25.5714 30.7745 24.1957 30.4462 22.9589C30.1672 21.9126 29.4927 20.962 28.5527 20.3839C27.5754 19.7734 26.3488 19.5938 25.2209 19.8275Z",
    fill: "url(#paint5_linear_1751_36383)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.751 16.929C48.4352 16.6945 50.2045 16.9324 51.7237 17.6984C53.1264 18.397 54.29 19.5473 54.9781 20.9321C56.2234 23.4073 55.9368 26.5679 54.1845 28.7453C53.123 30.0936 51.5587 31.0376 49.8643 31.4077C48.0473 31.8036 46.0867 31.6323 44.4033 30.8405C43.0236 30.195 41.8566 29.1204 41.1293 27.8038C40.2506 26.2335 40.0167 24.3497 40.3986 22.6064C40.7389 21.0494 41.6244 19.613 42.8773 18.5958C43.9729 17.6959 45.3364 17.1253 46.751 16.929ZM46.9985 19.8209C46.051 20.0064 45.1757 20.5229 44.5734 21.2632C43.1487 22.9948 43.2405 25.7461 44.8048 27.3663C45.8264 28.4559 47.4528 28.8992 48.9184 28.5965C50.1399 28.3669 51.2227 27.5643 51.7994 26.4889C52.7419 24.7531 52.4893 22.4193 51.0679 20.9987C50.0437 19.9424 48.442 19.5224 46.9985 19.8209Z",
    fill: "url(#paint6_linear_1751_36383)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00037805 17.0936C2.30129 17.0945 4.60219 17.0911 6.90395 17.0953C8.30406 17.1169 9.77732 17.4712 10.8236 18.4302C11.7848 19.2894 12.1939 20.6002 12.1709 21.8469C12.1897 23.0172 11.8162 24.2282 10.9724 25.0832C10.4451 25.6338 9.76456 26.0247 9.04664 26.2883C10.2443 27.9826 11.4318 29.6843 12.6269 31.3801C11.3748 31.3801 10.1227 31.3777 8.87057 31.3818C7.81496 29.8656 6.77125 28.341 5.71905 26.8231C4.88204 26.8231 4.04504 26.8231 3.20804 26.8231V31.3801C2.13882 31.3793 1.0696 31.3801 0.00037805 31.3801C-0.000472563 26.6177 0.00037805 21.8561 0.00037805 17.0936ZM3.20804 19.924C3.20804 21.288 3.20719 22.652 3.20889 24.0161H6.39018C6.93713 24.0169 7.50193 23.9329 7.97827 23.6559C9.03389 23.0804 9.19976 21.5292 8.46738 20.6484C7.99784 20.1194 7.24845 19.9456 6.5603 19.9257C5.44345 19.9207 4.32574 19.9248 3.20804 19.924Z",
    fill: "url(#paint7_linear_1751_36383)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6164 17.0936C64.9675 17.0953 67.3186 17.0895 69.6688 17.097C71.0417 17.1344 72.5175 17.5353 73.4251 18.6057C74.2 19.4807 74.3565 20.7441 74.0715 21.8378C73.8342 22.7568 73.1163 23.4696 72.3023 23.9395C73.0287 24.2173 73.7475 24.5883 74.2579 25.1805C74.7019 25.6895 74.9341 26.3499 74.9868 27.0111C75.077 27.9651 74.8932 28.9864 74.2629 29.7458C73.5255 30.6549 72.3559 31.1007 71.216 31.2895C70.2021 31.4658 69.1695 31.4117 68.1453 31.4209C66.3021 31.4201 64.4596 31.4209 62.6164 31.4201C62.6172 26.6451 62.6172 21.8694 62.6164 17.0936ZM65.767 19.8067C65.7653 20.8131 65.7662 21.8186 65.7662 22.825C66.6423 22.8234 67.5184 22.825 68.3946 22.8234C69.087 22.8591 69.8381 22.8309 70.4386 22.4491C71.0595 22.0549 71.1684 21.1649 70.829 20.5602C70.4879 20.0105 69.7836 19.845 69.1712 19.8134C68.0365 19.7992 66.9009 19.8134 65.767 19.8067ZM65.767 25.4583C65.7653 26.5021 65.7662 27.5467 65.7662 28.5905C67.0982 28.588 68.4294 28.5964 69.7607 28.5864C70.4352 28.5606 71.2246 28.4234 71.6252 27.8312C71.985 27.234 71.9161 26.3349 71.3181 25.9041C70.8248 25.5498 70.1885 25.4766 69.5939 25.4608C68.318 25.4558 67.0421 25.4616 65.767 25.4583Z",
    fill: "url(#paint8_linear_1751_36383)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6874 31.322C81.6908 26.5795 81.7027 21.8362 81.7078 17.0937C85.3714 17.0945 89.0359 17.0929 92.7003 17.0945C92.6978 18.0244 92.702 18.9551 92.6978 19.8849C90.0906 19.8825 87.4835 19.8858 84.8764 19.8833C84.8747 20.8439 84.8755 21.8037 84.8755 22.7635C87.1688 22.7652 89.462 22.7619 91.7553 22.7652C91.7553 23.6959 91.7544 24.6258 91.7553 25.5556C89.462 25.5548 87.1688 25.5556 84.8755 25.5556V28.5315C87.5167 28.5315 90.1578 28.5324 92.799 28.5307C92.799 29.4614 92.7981 30.3921 92.799 31.322C89.0954 31.3211 85.3919 31.322 81.6874 31.322Z",
    fill: "url(#paint9_linear_1751_36383)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6739 17.1136C102.702 17.1128 106.731 17.1128 110.759 17.1136V19.9997C109.287 20.0005 107.815 19.9989 106.343 20.0005C106.343 23.7874 106.344 27.575 106.343 31.3619C105.267 31.3627 104.191 31.3619 103.116 31.3619C103.116 27.575 103.116 23.7874 103.116 20.0005C101.635 19.9989 100.154 20.0005 98.6739 19.9997C98.673 19.0374 98.673 18.0751 98.6739 17.1136Z",
    fill: "url(#paint10_linear_1751_36383)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121.035 20.9295C121.082 19.8723 121.178 18.8169 121.359 17.7731C122.234 17.9968 123.105 18.233 123.977 18.4667C123.844 19.7085 123.713 20.9569 123.767 22.2078C123.824 24.0518 124.196 25.8782 124.805 27.6215C124.903 27.822 124.757 28.0149 124.57 28.0906C123.865 28.4499 123.211 28.8957 122.498 29.2375C121.613 26.9802 121.118 24.5816 121.035 22.1654V20.9295Z",
    fill: "url(#paint11_linear_1751_36383)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M161.05 28.2396C161.176 28.1705 161.316 28.2512 161.443 28.2778C162.173 28.5007 162.927 28.6404 163.653 28.8725C162.793 31.2595 161.473 33.4886 159.797 35.4165C158.54 36.8612 157.079 38.1312 155.489 39.2158C155.033 38.4481 154.578 37.6788 154.135 36.9036C155.12 36.1692 156.086 35.4024 156.94 34.5199C158.63 32.8057 159.963 30.7622 160.865 28.5523C160.918 28.4442 160.948 28.3144 161.05 28.2396Z",
    fill: "url(#paint12_linear_1751_36383)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.659 33.2914C125.431 32.8272 126.221 32.3914 127.003 31.9431C128.935 34.766 131.649 37.0682 134.791 38.5212C134.552 39.3929 134.315 40.2662 134.081 41.1395C132.131 40.2712 130.294 39.1492 128.674 37.7752C127.129 36.4735 125.789 34.949 124.659 33.2914Z",
    fill: "url(#paint13_linear_1751_36383)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M139.17 39.9617C142.789 40.6778 146.606 40.351 150.045 39.0393C150.503 39.8162 150.96 40.5938 151.424 41.3682C148.951 42.3571 146.301 42.926 143.628 43H142.439C141.104 42.9501 139.772 42.8037 138.462 42.5417C138.695 41.6809 138.941 40.8234 139.17 39.9617Z",
    fill: "url(#paint14_linear_1751_36383)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1751_36383",
    x1: 0,
    y1: 21.5,
    x2: 165,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1751_36383",
    x1: 0,
    y1: 21.5,
    x2: 165,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1751_36383",
    x1: 0,
    y1: 21.5,
    x2: 165,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1751_36383",
    x1: 0,
    y1: 21.5,
    x2: 165,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1751_36383",
    x1: 0,
    y1: 21.5,
    x2: 165,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1751_36383",
    x1: 0,
    y1: 21.5,
    x2: 165,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1751_36383",
    x1: 0,
    y1: 21.5,
    x2: 165,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1751_36383",
    x1: 0,
    y1: 21.5,
    x2: 165,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1751_36383",
    x1: 0,
    y1: 21.5,
    x2: 165,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1751_36383",
    x1: 0,
    y1: 21.5,
    x2: 165,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1751_36383",
    x1: 0,
    y1: 21.5,
    x2: 165,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1751_36383",
    x1: 0,
    y1: 21.5,
    x2: 165,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1751_36383",
    x1: 0,
    y1: 21.5,
    x2: 165,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1751_36383",
    x1: 0,
    y1: 21.5,
    x2: 165,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1751_36383",
    x1: 0,
    y1: 21.5,
    x2: 165,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoobetLabel);
export default __webpack_public_path__ + "static/media/roobetLabel.9d80310ddc8b687a9745a65b1c93f205.svg";
export { ForwardRef as ReactComponent };